import { jsx as _jsx } from "theme-ui/jsx-runtime";
export const SmallArrowDown = props => {
    return (_jsx("svg", Object.assign({ width: "12", height: "9", viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, props, { children: _jsx("path", { d: "M12 0.500002L6 5.93698L0 0.5L0 3.06302L6 8.5L12 3.06302V0.500002Z", fill: "currentColor" }) })));
};
//# sourceMappingURL=ArrowDownSmall.js.map